export default __webpack_public_path__ + "static/media/Garmin-logo.82e99475.png";